import React, { useState, useEffect } from "react";
import styles from "./pagination.module.css";

export default function Page({ page, isCurrent, goToPage }) {
  let [classes, setClasses] = useState(`${styles['page']} ${styles['page-num']}`)

  let updateClasses = () => {
    let classes = `${styles['page']} ${styles['page-num']} ${(isCurrent ? styles['current'] : "")}`;
    setClasses(classes);
  };

  useEffect(updateClasses, [isCurrent]);

  return (
    <div className={classes} onClick={() => goToPage(page)}>
      <span>{page}</span>
    </div>
  )
}